import './switch.css';
export default {
  "dirRtl": "pf-v5-m-dir-rtl",
  "modifiers": {
    "reverse": "pf-m-reverse",
    "off": "pf-m-off",
    "on": "pf-m-on"
  },
  "switch": "pf-v5-c-switch",
  "switchInput": "pf-v5-c-switch__input",
  "switchLabel": "pf-v5-c-switch__label",
  "switchToggle": "pf-v5-c-switch__toggle",
  "switchToggleIcon": "pf-v5-c-switch__toggle-icon",
  "themeDark": "pf-v5-theme-dark"
};